import React, { useContext, useMemo } from 'react';
import { DataContext } from '@visx/xychart';
import SolidGraphBackgroundModel from "../../models/background/SolidGraphBackgroundModel.js";
export default function SolidGraphBackground(props) {
  const {
    model
  } = props;
  const {
    theme,
    margin,
    width,
    height
  } = useContext(DataContext);
  const {
    backgroundColor
  } = useMemo(() => {
    const backgroundColor = SolidGraphBackgroundModel.getBackgroundColor(model) || theme?.backgroundColor || '#fff';
    return {
      backgroundColor
    };
  }, [theme?.backgroundColor, model]);

  // early return values not available in context
  if (width == null || height == null || margin == null || theme == null) return null;
  return /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: width,
    height: height,
    fill: backgroundColor
  });
}